import { OWNER_EMAILS } from '@/config/app.config'
import { useSession } from './useSession'

/**
 * "Is the person looking at this page the shop owner?"
 *
 * This site has exactly one privileged account. The address comes from
 * `VITE_OWNER_EMAIL` when set, otherwise `appConfig.ownerEmails` — see
 * src/config/app.config.ts. Everything under /studio hangs off this one flag,
 * so there is a single place to change who gets in.
 */
export function useOwner() {
  const { user, loading, signOut } = useSession()
  const email = user?.email?.toLowerCase() ?? ''
  const isOwner = !!email && OWNER_EMAILS.includes(email)

  return {
    user,
    loading,
    isOwner,
    /** Signed in, but with the wrong account — worth saying so plainly. */
    isWrongAccount: !loading && !!user && !isOwner,
    ownerEmail: OWNER_EMAILS[0] ?? '',
    signOut,
  }
}
